// extracted by mini-css-extract-plugin
export default {"wrapper":"Live_wrapper__d2Kvd","title":"Live_title__eexjZ"};